import React from "react";
import Navbar from "../navbar/navbar-desktop.tsx";
import Footer from "../footer/footer.tsx";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

const firemniFunkce = [
  {
    nadpis: "Flexibilní prostory",
    popis: "Kapacita až 170 osob včetně restaurace, salonků a terasy.",
  },
  {
    nadpis: "Prezentační technika",
    popis: "Dataprojektor, plátno, ozvučení a další vybavení pro školení.",
  },
  {
    nadpis: "Catering a rauty",
    popis: "Teplá i studená kuchyně a rauty připravené přesně na míru.",
  },
  {
    nadpis: "Ubytování",
    popis: "Až 10 zrekonstruovaných pokojů přímo v areálu.",
  },
  {
    nadpis: "Grillování na místě",
    popis: "Venkovní gril a zázemí pro neformální firemní posezení.",
  },
  {
    nadpis: "Parkování",
    popis: "Vlastní parkoviště až pro 25 aut hned u areálu.",
  },
  {
    nadpis: "Bez nočního klidu",
    popis: "Zábava může pokračovat dle vašich představ, klidně i s DJ.",
  },
  {
    nadpis: "Program na míru",
    popis: "Živá hudba, kapely a zastřešené pódium pro letní akce.",
  },
];

function Firmy() {
  return (
    <>
      {/* ====== HEAD ====== */}
      <Helmet>
        <title>Firemní akce | Hospůdka pod Rablinů</title>
        <meta
          name="description"
          content="Firemní akce, školení a teambuilding v Hospůdce pod Rablinů."
        />
      </Helmet>

      {/* ====== NAVBAR (IZOLOVANÝ) ====== */}
      <div className="relative z-50">
        <Navbar />
      </div>

      {/* ====== OBSAH STRÁNKY ====== */}
      <main className="bg-[#F5E7CC] text-[#531d08] overflow-x-hidden">

        {/* ================= MOBILE ================= */}
        <section className="block lg:hidden px-5 pt-24 space-y-6">

          {/* HERO */}
          <div className="text-center">
            <p className="text-[10px] uppercase tracking-[0.25em] text-[#8c5a3c]">
              Hospůdka pod Rablinů
            </p>
            <h1 className="text-2xl font-bold font-serif mt-2">
              Firemní akce
            </h1>
            <div className="w-10 h-px bg-[#c9a878] mx-auto mt-3" />
          </div>

          <p className="text-sm leading-relaxed text-center">
            Kombinace pracovního prostředí s možností večerní zábavy.
            U nás nemusíte řešit noční klid – akce může pokračovat dle vašich
            představ.
          </p>

          {/* OBRÁZEK */}
          <img
            src="./img/grillovani.webp"
            className="w-full h-56 object-cover rounded-xl shadow"
            alt="Grillování"
          />

          {/* FUNKCE – KARTY */}
          <div className="space-y-3 pt-2">
            {firemniFunkce.map((f) => (
              <div
                key={f.nadpis}
                className="bg-white rounded-2xl border border-[#e8d6b8] shadow-sm p-4 flex gap-3"
              >
                <span className="mt-1 w-6 h-6 shrink-0 rounded-full bg-[#f8efe1] flex items-center justify-center">
                  <span className="w-2 h-2 rounded-full bg-[#60260F]" />
                </span>
                <div>
                  <p className="font-bold font-serif text-[#60260F]">
                    {f.nadpis}
                  </p>
                  <p className="text-xs leading-relaxed text-[#3d2a1c]">
                    {f.popis}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* DOPRAVA / ODVOZ */}
          <div className="bg-white rounded-2xl border border-[#e8d6b8] shadow-md overflow-hidden mt-2">
            <img
              src="https://www.autanet.cz/img-vehicle/226/75915/toyota-proace-verso-20d-l2-business-comfort-25297538-4.jpg"
              className="w-full h-48 object-cover"
              alt="Odvoz hostů z firemní akce v Hospůdce pod Rablinů"
            />
            <div className="p-5">
              <p className="text-[10px] uppercase tracking-[0.25em] text-[#8c5a3c]">
                Doprava
              </p>
              <h2 className="text-lg font-serif text-[#60260F] mt-2">
                Postaráme se i o cestu domů
              </h2>
              <p className="text-xs leading-relaxed mt-3 text-[#3d2a1c]">
                K firemní akci umíme zajistit i svoz hostů a odvoz zpět, ať
                nikdo neřeší, kdo bude řídit. Trasu i čas přizpůsobíme programu
                vaší akce.
              </p>
              <p className="text-xs leading-relaxed mt-3 font-semibold text-[#60260F]">
                Dopravu je nutné domluvit předem s personálem, případně přímo
                s majitelem – kapacita je omezená.
              </p>
            </div>
          </div>

          {/* CTA */}
          <div className="bg-white rounded-2xl border border-[#e8d6b8] shadow-md p-5 text-center mb-10 mt-2">
            <h2 className="text-lg font-serif text-[#60260F]">
              Naplánujeme akci podle vás
            </h2>
            <p className="text-xs leading-relaxed mt-2">
              Napište nám své představy a připravíme nabídku na míru.
            </p>
            <div className="space-y-3 pt-5">
              <Link to="/rezervace-akce" className="block">
                <button className="w-full bg-[#60260F] text-white px-6 py-4 rounded-lg text-base font-semibold">
                  Nezávazná poptávka
                </button>
              </Link>
              <Link to="/kontakt" className="block">
                <button className="w-full border border-[#60260F] text-[#60260F] px-6 py-4 rounded-lg text-base font-semibold">
                  Kontakt
                </button>
              </Link>
            </div>
          </div>

        </section>

        {/* ================= DESKTOP ================= */}
        <section className="hidden lg:block text-[#531d08]">

          {/* HERO – BÍLÝ BLOK POD NAVBAREM */}
          <div className="bg-white py-20 text-center">
            <p className="text-[11px] uppercase tracking-[0.3em] text-[#8c5a3c]">
              Hospůdka pod Rablinů
            </p>
            <h1 className="text-4xl font-bold font-serif mt-3">
              FIREMNÍ AKCE
            </h1>
            <div className="w-12 h-px bg-[#c9a878] mx-auto mt-5" />
            <p className="max-w-3xl mx-auto mt-6 leading-relaxed text-lg">
              Ideální místo pro firemní porady, školení i večírky v klidném
              prostředí Hostýnských vrchů. Kombinace pracovního zázemí a večerní
              zábavy bez nutnosti řešit noční klid.
            </p>
          </div>

          {/* 3 FOTKY */}
          <div className="max-w-6xl mx-auto grid grid-cols-3 gap-6 mt-16 px-10">
            {[
              "./img/grillovani.webp",
              "./img/party.jpg",
              "./img/fotka-interier-2.jpg",
            ].map((src, i) => (
              <img
                key={i}
                src={src}
                className="h-72 w-full object-cover rounded-xl shadow"
                alt="Fotografie firemní akce v Hospůdce pod Rablinů"
              />
            ))}
          </div>

          {/* CO NABÍZÍME */}
          <div className="max-w-6xl mx-auto px-10 mt-24">
            <div className="text-center mb-12">
              <h2 className="text-2xl font-serif text-[#60260F]">
                Co u nás najdete
              </h2>
              <div className="w-12 h-px bg-[#c9a878] mx-auto mt-4" />
            </div>

            <div className="grid grid-cols-2 xl:grid-cols-4 gap-6">
              {firemniFunkce.map((f) => (
                <div
                  key={f.nadpis}
                  className="bg-white rounded-2xl border border-[#e0cbaa] shadow-[0_10px_30px_-15px_rgba(96,38,15,0.35)] p-6 flex flex-col gap-3"
                >
                  <span className="w-8 h-8 rounded-full bg-[#f8efe1] flex items-center justify-center">
                    <span className="w-2.5 h-2.5 rounded-full bg-[#60260F]" />
                  </span>
                  <p className="font-bold text-lg font-serif text-[#60260F]">
                    {f.nadpis}
                  </p>
                  <p className="text-sm leading-relaxed text-[#3d2a1c]">
                    {f.popis}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* DOPRAVA / ODVOZ */}
          <div className="max-w-6xl mx-auto px-10 mt-24">
            <div className="bg-white rounded-2xl border border-[#e0cbaa] shadow-[0_10px_30px_-15px_rgba(96,38,15,0.35)] overflow-hidden grid grid-cols-1 xl:grid-cols-2">
              <img
                src="https://www.autanet.cz/img-vehicle/226/75915/toyota-proace-verso-20d-l2-business-comfort-25297538-4.jpg"
                className="h-72 xl:h-full w-full object-cover"
                alt="Odvoz hostů z firemní akce v Hospůdce pod Rablinů"
              />
              <div className="p-10 flex flex-col justify-center">
                <p className="text-[11px] uppercase tracking-[0.3em] text-[#8c5a3c]">
                  Doprava
                </p>
                <h2 className="text-2xl font-serif text-[#60260F] mt-3">
                  Postaráme se i o cestu domů
                </h2>
                <div className="w-12 h-px bg-[#c9a878] mt-5" />
                <p className="leading-relaxed mt-6">
                  K firemní akci umíme zajistit i svoz hostů a odvoz zpět, ať
                  nikdo z týmu neřeší, kdo bude řídit. Trasu i čas odjezdu
                  přizpůsobíme programu vaší akce.
                </p>
                <p className="leading-relaxed mt-4 font-semibold text-[#60260F]">
                  Dopravu je nutné domluvit předem s personálem, případně přímo
                  s majitelem – kapacita je omezená.
                </p>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="bg-white mt-24 py-16 text-center">
            <h2 className="text-2xl font-serif text-[#60260F]">
              Naplánujeme akci přesně podle vás
            </h2>
            <p className="max-w-2xl mx-auto mt-4 leading-relaxed">
              Napište nám své představy a my připravíme nabídku na míru –
              od cateringu přes techniku až po ubytování.
            </p>
            <div className="flex justify-center gap-4 mt-8">
              <Link to="/rezervace-akce">
                <button className="bg-[#60260F] hover:bg-[#965126] text-white px-12 py-4 rounded-xl text-lg font-semibold transition-colors">
                  Nezávazná poptávka
                </button>
              </Link>
              <Link to="/kontakt">
                <button className="border border-[#60260F] text-[#60260F] hover:bg-[#60260F] hover:text-white px-12 py-4 rounded-xl text-lg font-semibold transition-colors">
                  Kontakt
                </button>
              </Link>
            </div>
          </div>
        </section>
      </main>

      {/* ====== FOOTER (IZOLOVANÝ) ====== */}
      <div className="relative z-10">
        <Footer />
      </div>
    </>
  );
}

export default Firmy;
